import React from 'react';
import { Dialog, DialogCloseButton } from '../../../components/dialog';

export function ConnectionsHowItWorksDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const vcardHref = `data:text/vcard;charset=utf-8,${encodeURIComponent(
    [
      'BEGIN:VCARD',
      'VERSION:3.0',
      'FN:Sendit Gigs Provider Support',
      'ORG:Sendit Gigs',
      `TEL;TYPE=CELL:${window.SENDIT_CONTACT_INFO?.automated_text_sender_number ?? ''}`,
      `EMAIL:${window.SENDIT_CONTACT_INFO?.provider_support_email ?? ''}`,
      'END:VCARD',
    ].join('\r\n')
  )}`;

  return (
    <Dialog open={open} onClose={onClose} size="lg" align="top">
      <div className="tw:flex tw:flex-col tw:max-h-[85vh] tw:overflow-hidden">
        <div className="tw:flex tw:items-start tw:justify-between tw:gap-4 tw:shrink-0">
          <div className="tw:flex tw:items-center tw:gap-2">
            <i className="far fa-handshake tw:text-brand-green-0 tw:text-2xl" />
            <span className="tw:font-semibold tw:text-lg">How Connections Work</span>
          </div>
          <DialogCloseButton onClick={onClose} className="tw:shrink-0" />
        </div>

        <div className="tw:flex-1 tw:overflow-y-auto tw:mt-6 tw:space-y-4">
          <div className="tw:flex tw:gap-4 tw:p-4 tw:rounded-lg tw:bg-zinc-100">
            <div className="tw:shrink-0 tw:w-10 tw:h-10 tw:rounded-lg tw:bg-brand-green-0 tw:flex tw:items-center tw:justify-center">
              <i className="far fa-search tw:text-white tw:text-lg" />
            </div>
            <div>
              <p className="tw:!mb-1 tw:font-semibold">Automatic opportunity matching</p>
              <p className="tw:!mb-0 tw:text-sm tw:text-zinc-600">
                We look for opportunity matches at least twice a day. If we find a match based on
                your specialty, boards, and state licenses you will receive an email notification
              </p>
            </div>
          </div>

          <div className="tw:flex tw:gap-4 tw:p-4 tw:rounded-lg tw:bg-zinc-100">
            <div className="tw:shrink-0 tw:w-10 tw:h-10 tw:rounded-lg tw:bg-brand-green-0 tw:flex tw:items-center tw:justify-center">
              <i className="far fa-comment-alt tw:text-white tw:text-lg" />
            </div>
            <div>
              <p className="tw:!mb-1 tw:font-semibold">Text alerts (if opted in)</p>
              <p className="tw:!mb-0 tw:text-sm tw:text-zinc-600">
                If you opted in to text messages, you will also receive an SMS when a match is
                found.
              </p>
            </div>
          </div>

          <div className="tw:flex tw:gap-4 tw:p-4 tw:rounded-lg tw:bg-zinc-100">
            <div className="tw:shrink-0 tw:w-10 tw:h-10 tw:rounded-lg tw:bg-brand-green-0 tw:flex tw:items-center tw:justify-center">
              <i className="far fa-bell-slash tw:text-white tw:text-lg" />
            </div>
            <div>
              <p className="tw:!mb-1 tw:font-semibold">Cut out the noise</p>
              <p className="tw:!mb-0 tw:text-sm tw:text-zinc-600">
                When you decline a connection, we use your reason to pause similar requests for a
                period of time, so that we&apos;re not sending you opportunities you&apos;re not
                interested in.
              </p>
            </div>
          </div>

          <div className="tw:flex tw:gap-4 tw:p-4 tw:rounded-lg tw:bg-brand-green-3 tw:border tw:border-brand-green-2">
            <div className="tw:shrink-0 tw:w-10 tw:h-10 tw:rounded-lg tw:bg-brand-cta tw:flex tw:items-center tw:justify-center">
              <i className="far fa-redo tw:text-white tw:text-lg" />
            </div>
            <div>
              <p className="tw:!mb-1 tw:font-semibold">Re-enable text notifications</p>
              <p className="tw:!mb-0 tw:text-sm tw:text-zinc-600">
                If you previously opted out of text messages and wish to receive them again, text{' '}
                <code className="tw:bg-zinc-200 tw:px-1 tw:rounded tw:font-mono tw:text-xs">
                  START
                </code>{' '}
                to{' '}
                <a
                  href={`sms:${window.SENDIT_CONTACT_INFO?.automated_text_sender_number ?? ''}`}
                  className="tw:font-semibold tw:text-brand-green-0 tw:whitespace-nowrap"
                >
                  {(window.SENDIT_CONTACT_INFO?.automated_text_sender_number ?? '').replace(
                    /^\+1(\d{3})(\d{3})(\d{4})$/,
                    '$1-$2-$3'
                  )}
                </a>{' '}
                and save it to your contacts.
              </p>
            </div>
          </div>
          <a
            href={vcardHref}
            download="sendit-support.vcf"
            className="tw:flex tw:items-center tw:justify-center tw:gap-2 tw:w-full tw:rounded-lg
             tw:bg-brand-green-1 tw:!text-white tw:border tw:border-brand-green-0 tw:py-2
             tw:px-4 tw:text-base tw:font-medium tw:!no-underline hover:tw:bg-brand-green-3"
          >
            <i className="far fa-address-card fa-lg" />
            Save Sendit to contacts
          </a>
        </div>
      </div>
    </Dialog>
  );
}
